import { useEffect, useState } from "react";
import { Route } from "react-router-dom";

export default function ProtectedRoute({
  component: Component,
  ...restOfProps
}) {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const jwt = require("jsonwebtoken");

  useEffect(() => {
    const token = localStorage.getItem("gdfhgfhtkn");
    if (token) {
      try {
        var decoded = jwt.decode(token);
        if (Date.now() >= decoded.exp * 1000) {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const logout = () => {
    fetch("/api/auth/logout", {
      method: "get",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setIsAuthenticated(false);
        localStorage.clear();
        window.location.href = "/login";
      })
      .catch((error) => {
        window.location.href = "/login";
      });
  };

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : logout()
      }
    />
  );
}
